import { render, staticRenderFns } from "./shipment.vue?vue&type=template&id=b76c81e0&scoped=true&"
import script from "./shipment.vue?vue&type=script&lang=js&"
export * from "./shipment.vue?vue&type=script&lang=js&"
import style0 from "./shipment.vue?vue&type=style&index=0&id=b76c81e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76c81e0",
  null
  
)

export default component.exports